var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.55 50.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.71,15.8a8.85,8.85,0,0,0-8,3.49A8.88,8.88,0,1,0,51,30.58a12.27,12.27,0,0,1,3.31,8.19v6.16A3.69,3.69,0,0,0,58,48.62h0a3.69,3.69,0,0,0,3.69-3.69V37.36a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3v7.57a3.69,3.69,0,0,0,3.68,3.69h0a3.69,3.69,0,0,0,3.69-3.69V38.77a12.26,12.26,0,0,1,3.3-8.19A8.88,8.88,0,0,0,72.71,15.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.58,26.49a8.84,8.84,0,0,0-8.12-3.18,8.87,8.87,0,1,0-17.65-1.69,12.3,12.3,0,0,1-3.46,8.13L15,34.1a3.7,3.7,0,0,0,0,5.21h0a3.69,3.69,0,0,0,5.22,0L25.56,34a3,3,0,0,1,4.25,0h0a3,3,0,0,1,0,4.25l-5.35,5.35a3.68,3.68,0,0,0,0,5.21h0a3.68,3.68,0,0,0,5.21,0L34,44.42A12.3,12.3,0,0,1,42.15,41a8.87,8.87,0,0,0,6.43-14.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.66,35.23c7.87,2.27,14.13,5.46,17.89,9.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,44.48C3.93,41.55,8.37,39,13.93,36.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.13,
    y1: 7.36,
    x2: 45.13,
    y2: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.45,
    y1: 9.79,
    x2: 36.1,
    y2: 5.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.81,
    y1: 9.79,
    x2: 54.16,
    y2: 5.14
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset15);
export default __webpack_public_path__ + "static/media/Asset 15.67d47cc79dd7c4924711dc821651dcb4.svg";
export { ForwardRef as ReactComponent };